export const excludedRoutesToSanitize = [
  '/media',
  '/profile_picture',
  '/user_massive_imports',
  '/bill',
  '/transfer'
]

export const urlIsSanitizable = (url) => {
  for (let el of excludedRoutesToSanitize) {
    if (url.includes(el)) {
      return false
    }
  }
  return true
}
